import { render } from "./addEditUser.vue?vue&type=template&id=1b966303"
import script from "./addEditUser.vue?vue&type=script&lang=js"
export * from "./addEditUser.vue?vue&type=script&lang=js"

import "./addEditUser.vue?vue&type=style&index=0&id=1b966303&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__